module.exports = __webpack_public_path__ + "assets/img/5dda21b027d7250fe3d2068d853cb2f0.png";